@if(component){
<div class="w-12"
     [class]="component.bgColor || 'bg-col-52'">
    <div class="wrap flex flex-justify-center p-t-10 p-b-10">
        <div class="_wrapper flex flex-column-s flex-column-m">
            <text-box [data]="component"
                      [textAlign]="'left'" />
            <div class="_tab-wrapper">
                @for(item of component.items; track $index) {
                <div class="bg-col-w"
                     style="border-radius: 12px;"
                     [class.m-t]="!$first">
                    <button class="p-a flex flex-middle flex-justify-between w-12 left"
                            type="button"
                            (click)="toggle($index)">
                        <div class="flex flex-middle">
                            <i [class]="item.icon || ''"
                               class="m-r"
                               [style.fontSize.px]="client.sizeId > 1 ? 32 : 24"></i>
                            <p class="h2 h4-s h4-m"
                               *iCms="'title' of item"></p>
                        </div>
                        <i style="font-size: 24px"
                           [toggleClass]="'icon-minus !icon-plus'"
                           [toggleClassBy]="getState($index)"></i>
                    </button>
                    <hide-up [open]="getState($index)">
                        <p class="m-l m-r m-b p1"
                           [style]="client.sizeId > 1 ? 'max-width:741px': 'max-width:323px'"
                           *iCms="'subtitle' of item"></p>
                        @if(item.buttonCopy){
                        <href [link]="item.buttonLink">
                            <span [buttonStyle]="item.buttonStyle || 'button-1'"
                                  class="m-l m-r m-b">
                                <span *iCms="'buttonCopy' of item;"></span>
                            </span>
                        </href>
                        }
                    </hide-up>
                </div>
                }
            </div>
        </div>
    </div>
</div>
}